import React from 'react'
import PropTypes from 'prop-types'
import { Avatar } from '@PipelineDeals/shared-react-components'

import {
  HeaderContainer,
  HeaderAvatarContainer,
  HeaderOptionsContainer
} from 'components/BusinessCard/components/StyledComponents'

import { useBusinessCard } from 'components/BusinessCard/context'

import AvatarUploader from 'components/BusinessCard/components/AvatarUploader'
import Titles from 'components/BusinessCard/components/Titles'
import Options from 'components/BusinessCard/components/Options'
import IdBadgeContainer from 'components/BusinessCard/components/IdBadgeContainer'

import { imageMissing } from 'components/BusinessCard/helpers'

const Header = ({ showAvatar = true }) => {
  const {
    callbacks: {
      avatarUpdateCallback
    },
    resource,
    resourceType
  } = useBusinessCard()

  const recordType = resourceType.toLowerCase()

  const getFallbackIcon = () => {
    switch (recordType) {
      case 'company':
        return <i className="fas fa-building" />
      case 'deal':
        return <i className="fas fa-briefcase" />
      case 'project':
        return <i className="fas fa-folder" />
      case 'person':
        return null
      default:
        return null
    }
  }

  const getResourceName = () => {
    if (recordType === 'person') {
      return resource.full_name || ''
    }
    return resource.name || ''
  }

  // eslint-disable-next-line react/prop-types
  const ConditionalAvatarUploader = ({ children }) => {
    return (
      <>
        {avatarUpdateCallback ? (
          <AvatarUploader record={resource} recordType={recordType} callback={avatarUpdateCallback}>
            {children}
          </AvatarUploader>
        ) : (
          <>
            {children}
          </>
        )}
      </>
    )
  }

  return (
    <>
      <HeaderContainer className="business-card-header">
        <HeaderAvatarContainer>
          {showAvatar && (
            <ConditionalAvatarUploader>
              <Avatar
                contentUrl={resource.image_thumb_url}
                hasUploadedAvatar={!imageMissing(resource)}
                name={getResourceName()}
                fallbackIcon={getFallbackIcon()}
                size="md"
              />
            </ConditionalAvatarUploader>
          )}
          <Titles />
        </HeaderAvatarContainer>
        <HeaderOptionsContainer>
          <IdBadgeContainer />
          <Options />
        </HeaderOptionsContainer>
      </HeaderContainer>
    </>
  )
}

export default Header

Header.propTypes = {
  showAvatar: PropTypes.bool
}
